function getMetaEnvironmentVariable(name) {
  const tag = document.head.querySelector(`meta[type='env'][name='${name}']`);
  return tag?.getAttribute('content') || '';
}

const ENV_KEYS = [
  'API_URL',
  'APP_ECS',
  'APP_ENV',
  'APP_REVISION',
  'APP_VERSION',
  'DYNAMIC_ASSET_HOST',
  'GOOGLE_MAP_API_KEY',
  'GOOGLE_ANALYTICS_ID',
  'STRIPE_KEY',
];

const Environment = Object.fromEntries(
  ENV_KEYS.map(key => [key, getMetaEnvironmentVariable(key)])
);

module.exports = Environment
